export const ColorPreview = ({color, diameter = 70, label = 'Color', code='RAL 9010', handleColorClick = null, selected = false}) => {


    return(
        <div
        key={color}
        onClick={() => handleColorClick(code)}
        className={`rounded-full shadow-lg cursor-pointer border transition ${
          selected ? 'border-4 border-blue-600' : 'border-gray-300'
        }
        text-gray-900 border bg-gray-50 
        `}
        style={{ backgroundColor: color, width: diameter, height: diameter }}
        title={label}
      />

    )

}